import { useEffect } from "react";

export function usePopupTrigger(onTrigger, location) {
  useEffect(() => {
    const excludedRoutes = ["/login", "/create"];
    const popupClosed = localStorage.getItem("popupClosed");

    // Don't show on excluded routes or if user already closed
    if (popupClosed || excludedRoutes.includes(location.pathname)) return;

    const timer = setTimeout(() => {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const scrollY = window.scrollY || window.pageYOffset;

            if (scrollY > 800) {
              onTrigger(); // Trigger the popup
              window.removeEventListener("scroll", handleScroll);
            }

            ticking = false;
          });

          ticking = true;
        }
      };

      window.addEventListener("scroll", handleScroll);

      // Cleanup on unmount
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, 10000); // 10 seconds delay

    return () => clearTimeout(timer);
  }, [location, onTrigger]);
}
